import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  defaultPlaceholder: {
    id: 'company-hub.article-search-component.placeholder.non-final',
    defaultMessage: 'Search for help',
    description: 'Default placeholder text for the article search input.'
  }
});